import { createLabeledMessages } from '../../../messageUtils';
const days = {
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
    sunday: 'sunday',
    monday_short: 'mon',
    tuesday_short: 'tue',
    wednesday_short: 'wed',
    thursday_short: 'thu',
    friday_short: 'fri',
    saturday_short: 'sat',
    sunday_short: 'sun'
};
const months = {
    january: 'january',
    february: 'february',
    march: 'march',
    april: 'april',
    may: 'may',
    june: 'june',
    july: 'july',
    august: 'august',
    september: 'september',
    october: 'october',
    november: 'november',
    december: 'december'
};
const messages = Object.assign({}, days, months);
export default Object.assign({}, messages, createLabeledMessages(messages));
